import React from 'react';
import { CalendarDays, Play } from 'lucide-react';
import { DAY_START, HOUR_HEIGHT, MIN_ENTRY_PX } from '../lib/calendar.js';
import { fmtTime } from '../lib/time.js';

export function CalendarEventBlock({
  event,
  onOpen,
  onStartTimer,
  timerActive,
  col = 0,
  cols = 1,
  hourHeight = HOUR_HEIGHT,
}) {
  const tooltip = `${event.subject} (${fmtTime(event.start)} - ${fmtTime(event.end)})`;
  return (
    <button
      type="button"
      data-calendar-event
      className="cal-outlook-event"
      onMouseDown={(mouseEvent) => mouseEvent.stopPropagation()}
      onClick={(mouseEvent) => {
        mouseEvent.stopPropagation();
        onOpen();
      }}
      style={{
        top: (event.start - DAY_START) * hourHeight,
        height: Math.max(MIN_ENTRY_PX, (event.end - event.start) * hourHeight),
        left: cols > 1 ? `${(col / cols) * 100}%` : 0,
        width: cols > 1 ? `calc(${(1 / cols) * 100}% - 3px)` : undefined,
      }}
    >
      <span className="cal-outlook-event-body">
        <span className="cal-outlook-event-title">
          <CalendarDays size={12} /> {event.subject}
        </span>
        <span>
          {fmtTime(event.start)}-{fmtTime(event.end)}
        </span>
      </span>
      {/* One shortcut, not two: clicking the block already logs the event as
          an entry, so the only action that needs its own target is the
          timer — and a single one fits a short block at a usable size. */}
      <span className="cal-outlook-event-actions">
        <span
          className={`cal-outlook-event-action${timerActive ? ' disabled' : ''}`}
          data-tooltip={
            timerActive
              ? 'A timer is already running'
              : 'Start timer for this event'
          }
          onMouseDown={(mouseEvent) => mouseEvent.stopPropagation()}
          onClick={(mouseEvent) => {
            mouseEvent.stopPropagation();
            if (!timerActive) onStartTimer();
          }}
        >
          <Play size={11} />
        </span>
      </span>
      <span className="cal-entry-tooltip">{tooltip}</span>
    </button>
  );
}
